import app from "./app";
import { combineReducers } from "redux";

const baseReducer = combineReducers({
  common: app
})
export default baseReducer;
